import {
	IFloodgateStorageProvider,
	FloodgateStorageProviderFileType,
	EcsCachedConfig,
	EcsConfigType,
	EcsResponseBase,
	IECSStorageProvider
} from "@ms-ofb/floodgate-shared-typings";
import * as SyncTasks from 'synctasks';

type EcsCachedConfigType<T> = EcsCachedConfig<T & EcsResponseBase>;

export default class StorageProvider implements IECSStorageProvider {
	hostStorageProvider: IFloodgateStorageProvider;
	constructor(storageProvider: IFloodgateStorageProvider) {
		this.hostStorageProvider = storageProvider;
	}
	put<T>(config: EcsCachedConfigType<T>): Promise<void> {
		// Write the new config
		this.hostStorageProvider.write(FloodgateStorageProviderFileType.DynamicCampaignDefinitions, JSON.stringify(config));
		return Promise.resolve();
	}
	pull<T>(): Promise<EcsCachedConfigType<T>> {
		let config: unknown;
		try {
			config = JSON.parse(this.hostStorageProvider.read(FloodgateStorageProviderFileType.DynamicCampaignDefinitions));
		} catch (e) {
			config = {};
		}
		return new Promise<EcsCachedConfigType<T>>((resolve) => resolve(config as unknown as EcsCachedConfigType<T>));
	}

	// Required functions for Skype Ecs Client.
	putData<T>(_type: EcsConfigType, config: EcsCachedConfig<T & EcsResponseBase>): SyncTasks.Promise<void> {
		this.put<T>(config);
		return SyncTasks.Resolved();
	}

	getData<T>(_type: EcsConfigType): SyncTasks.Promise<EcsCachedConfigType<T>> {
		return SyncTasks.fromThenable(this.pull<T>());
	}
}
